module.exports = __webpack_public_path__ + "img/delta_to_star_trafo 2.8b70ad5d.svg";